import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink, concat } from 'apollo-link';

const uri = window.location.host.includes('localhost')
  ? 'http://localhost:9000/graphql'
  : '//munityapi.herokuapp.com/graphql';

const httpLink = new HttpLink({ uri });

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      authorization: localStorage.getItem('jwt') || null,
    },
  });

  return forward(operation);
});

export default new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache(),
});



// WEBPACK FOOTER //
// ./src/core/apollo.js